import { render } from "./DemograTable.vue?vue&type=template&id=16280848"
import script from "./DemograTable.vue?vue&type=script&lang=js"
export * from "./DemograTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__